/**
 * PurchaseOrderPDF — wrapper liviano que mapea una PurchaseOrder al
 * BinimelizPDFLayout compartido. El tipo de documento (solicitud de
 * cotización vs orden de compra) se decide según po.status.
 */
import React from "react";
import BinimelizPDFLayout from "../design-system/BinimelizPDFLayout";

const padOC = n => n ? "OCC-" + String(n).padStart(4, "0") : "— borrador —";

const PurchaseOrderPDF = ({ order, provider, onClose }) => {
  if (!order) return null;

  // Tipo PDF según status
  const tipo =
    order.status === "cotizando" || order.status === "cotizado"
      ? "solicitud_cotizacion"
      : "orden_compra";

  // Recipiente = el proveedor
  const prov = provider || order.provider || {};
  const recipiente = {
    rolLabel:        "INFORMACION PROVEEDOR.",
    razon:           prov.name || order.providerName || "—",
    rut:             prov.rut  || order.providerRut  || "—",
    direccion:       prov.address || "—",
    contactoNombre:  prov.contactName || "—",
    contactoEmail:   prov.email || "—",
    contactoTel:     prov.phone || "—",
  };

  // Items mapeados al shape del layout
  const items = (order.items || []).map(it => ({
    cant:           Number(it.quantity) || 0,
    detalle:        [
      it.description,
      it.material  ? `Material: ${it.material}` : null,
      it.unit      ? `Unidad: ${it.unit}`       : null,
      // 30-sep-2026: la nota de la línea es interna (SKU y medida terminada); no va al proveedor.
    ].filter(Boolean).join(" · "),
    valorUnitario:  Number(it.pUnit) || 0,
    valorTotal:     (Number(it.quantity) || 0) * (Number(it.pUnit) || 0),
  }));

  return (
    <BinimelizPDFLayout
      tipo={tipo}
      numero={padOC(order.number)}
      fecha={order.date || order.createdAt || new Date()}
      recipiente={recipiente}
      items={items}
      nota={order.externalNotes || ""}
      observaciones={{
        plazoEntrega:    order.etaDate ? new Date(order.etaDate).toLocaleDateString("es-CL") : "según acuerdo",
        lugarEntrega:    "El Juncal 240, Bodega 47, Quilicura, RM", // 30-sep-2026: bodega de recepción de material
        condicionesPago: "30 días contra factura",
        validez:         tipo === "solicitud_cotizacion" ? "Solicitamos cotización válida 15 días" : "según acuerdo",
      }}
      footer={{
        firmanteNombre: "p.p. BINIMELIZ S.A.",
        firmanteCargo:  "",
      }}
      onClose={onClose}
    />
  );
};

export default PurchaseOrderPDF;
